import { render, staticRenderFns } from "./TabIdeacion.vue?vue&type=template&id=443f2aa3&"
import script from "./TabIdeacion.vue?vue&type=script&lang=js&"
export * from "./TabIdeacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports